const roundTheNumber = (number) => {
  return parseFloat(number).toFixed(2);
};

export default roundTheNumber;
